import React, { useState } from 'react'
import styled from 'styled-components'
import { IoMdDownload } from 'react-icons/io'

// Components
import { S_EmptyMessage } from '../EmptyMessage'
import { S_InvoiceManager } from '../InvoiceManager'
import { ControlsButton } from '../ControlsButton'

// Helpers
import { downloadDocument } from '../../_services/documents.service'

// Styled Componenets
export const S_DocumentsList = styled.div`
  h3 {
    margin-bottom: 20px;
  }

  ${S_EmptyMessage} {
    background: #f1f1f1;
  }
`

const handleDocumentDownload = (documentId, documentName) => {
  downloadDocument(documentId, documentName)
}

export const DocumentList = ({ title = 'Documents', documents = [] }) => {
  const [isOpen, setIsOpen] = useState(false)

  const numDocuments = documents && documents.length ? documents.length : 0

  return (
    <S_InvoiceManager className="compact">
      <header>
        <div className="left">
          <h4>{title}</h4>
          <div className="count-indicator">{documents.length}</div>
        </div>

        <div className="right">
          {numDocuments > 0 && (
            <ControlsButton handleClick={() => setIsOpen(!isOpen)} icon={isOpen ? 'less' : 'more'} />
          )}
        </div>
      </header>

      {numDocuments > 0 && isOpen && (
        <div className="main-expandable-content">
          {documents &&
            documents.length > 0 &&
            documents.map((doc, i) => (
              <div
                className="document"
                key={i}
                onClick={() => {
                  handleDocumentDownload(doc.id, doc.document_name)
                }}
              >
                <IoMdDownload />
                {doc.document_name}
              </div>
            ))}
        </div>
      )}
    </S_InvoiceManager>
  )
}
